import _ from 'lodash'
import { GetLatestAssignment } from '../utilities/TreeHelper';

export const TreeNodeTypes = [
  { key:"BUILDING", name: "Building", code: "BUILDING", icon: "fas fa-home" },
  { key:"WING", name: "Wing", code: "WING", icon: "Wing" },
  { key:"UNIT", name: "Unit", code: "UNIT", icon: "Unit"},
  { key: "FLOOR", name: "Floor", code: "FLOOR", icon: "fas fa-layer-group" },
  { key:"ROOM", name: "Room", code: "ROOM", icon: 'Room' },
  {key:"BED", name:"Bed", code: "BED", icon: "fas fa-bed"}
];

export const typeOptions = { isBuilding: false, isFloor: false, isWing:false, isUnit:false, isRoom: false, isBed: false };

export const SearchTree = (element, propToLook, searchKey, ignoreKey= '') => {
  if (_.toUpper(element[propToLook]) === _.toUpper(searchKey) && !_.isEqual(element.key, ignoreKey)) {
    return element;
  } else if (element.children != null) {
    var i;
    var result = null;
    for (i = 0; result === null && i < element.children.length; i++) {
      if(_.isEqual(element.children[i].key, ignoreKey))
      continue;
      result = SearchTree(element.children[i], propToLook, searchKey);
    }
    return result;
  }
  return null;
};

const scanTree = (node, path = [], result = [], ignoreKey='')=>{
  let obj = null;
  if(_.has(node, "children") && !node.children.length){
      obj = {id: node.id, key:node.key, code: `${node.id}`, type:node.type, name:node.label, parentId:node.parentId, active: node.active}
      result.push(path.concat(node.type === 'BED'? {...obj, assignmentId:_.has(node.data, "assignments")?(_.isEmpty(GetLatestAssignment(node.data.assignments))?null :GetLatestAssignment(node.data.assignments).assignmentId) : null}:obj));
  }
  if(_.has(node, "children")){
  for(const child of node.children)  {   
    if(_.isEqual(child.key, ignoreKey)){
      obj= {id: node.id, key:node.key, code: `${node.id}`, type:node.type, name:node.label, parentId:node.parentId, active: node.active}
      result.push(path.concat(node.type === 'BED'? {...obj, assignmentId:_.has(node.data, "assignments")?(_.isEmpty(GetLatestAssignment(node.data.assignments))?null :GetLatestAssignment(node.data.assignments).assignmentId) : null}:obj));
      continue;
    }
    obj = {id: node.id, key:node.key, code: `${node.id}`, type:node.type,  name:node.label, parentId:node.parentId, active: node.active}
    scanTree(child, path.concat(node.type === 'BED'? {...obj, assignmentId:_.has(node.data, "assignments")?(_.isEmpty(GetLatestAssignment(node.data.assignments))?null :GetLatestAssignment(node.data.assignments).assignmentId) : null}:obj), result, ignoreKey);
  }
}
  return result;
}   
export const GetNodesByType = (element, type, ignoreKey = '') =>{
   const treeArray = _.uniqBy(scanTree(element, [], [], ignoreKey).flat(), 'key');   
  const nodes = _.filter(treeArray, (t)=> {return _.upperCase(t.type) === type}) 
  return _.sortBy(nodes, ['name']);
}

export const GetAvailableBedCapacity = (treeData, key, ignoreId)=>{
  var parent = SearchTree(treeData, "key", key || 0);
  if(!_.isNull(parent) && parent.bedCapacity > 0){
    if(parent.type === "ROOM"){
      return parent.bedCapacity;
    }
    var availableBedCapacity = parent.bedCapacity -  _.sumBy(_.filter(parent.children, (t)=>{return t.key !== ignoreId}), (c)=> { return c.bedCapacity; })
    return availableBedCapacity;
  }
  return 2147483647; // Max integer value

}

export const ValidateBedCapacity = (availableBedCapacity, enteredBedCapacity)=>{
  let error=""; 
  if (+enteredBedCapacity > availableBedCapacity){
    error = availableBedCapacity > 0? `Bed capacity is more than available capacity of ${availableBedCapacity} ` : 'Max capacity reached.Please increase capacity at parent level'
  }
  return error;
}

export const ExceedsBedLimit = (treeData, model)=>{
    const availableCapacity = GetAvailableBedCapacity(treeData, model.room.key, model.key)
    const room =  SearchTree(SearchTree(treeData, "label", model.building.name), "label", `${model.room.name}`);
    if(availableCapacity <= room.children.length){
      return true;            
    }
    return false;
}

export const GetNode = (formData) => {
  var node =  {
    id:formData.model.id,
    key: _.isEmpty(formData.model.key)?`${formData.model.name}` : formData.model.key,
    label: _.trimEnd(`${formData.model.name}`),
    type: _.upperCase(formData.type.name),
    parentId: _.isEqual(formData.type.code, 'BUILDING')?formData.model.location.key 
              :_.isEqual(formData.type.code, 'BED')? formData.model.room.key
              :_.isEmpty(formData.model.parent)?formData.model.building.key :  formData.model.parent.key,
    bedCapacity:_.get(formData.model, "bedCapacity") || 0,
    children: [],
    data:{
      name:_.trimEnd(`${formData.model.name}`),
      currentStatus:"",
      action:""
    },
    active: formData.model.isActive
  };
  if(formData.type === "BED")
    node = {...node, status: "Unoccupied"} 
  return node;
};


export const HasRoomsUnderBuilding = (treeData, data)=>{
    var building = SearchTree(treeData, "key", data.key)   
    var index = _.findIndex(building.children, (n)=>{return n.type === 'ROOM'});
    return index >= 0?true: false;
}

export const HasFloorsUnderBuilding = (treeData, key, ignoreKey = '')=>{
  var building = SearchTree(treeData, "key", key)   
  var index = _.findIndex(GetNodesByType(building, "FLOOR", ignoreKey), (n)=>{return n.type === 'FLOOR'});
  return index >= 0?true: false;
}

export const HasWingsUnderBuilding = (treeData, key, ignoreKey = '')=>{
  var building = SearchTree(treeData, "key", key)   
  var index = _.findIndex(GetNodesByType(building, "WING", ignoreKey), (n)=>{return n.type === 'WING'});
  return index >= 0?true: false;
}

export const HasUnitsUnderBuilding = (treeData, key, ignoreKey = '')=>{
  var building = SearchTree(treeData, "key", key)   
  var index = _.findIndex(GetNodesByType(building, "UNIT", ignoreKey), (n)=>{return n.type === 'UNIT'});
  return index >= 0?true: false;
}

const NameExpression =  /^[0-9a-zA-Z-'*,&.()#\s]+$/
export const ValidateCharacters = (name)=>{
  return NameExpression.test(name);
}


export const GetDefaultParentType = ()=>{
  return TreeNodeTypes[0];
}

export const GetSelectedTypeOptions = (type)=>{
  let options = typeOptions;
        switch(type){
            case "BUILDING":               
                options = {...typeOptions, isBuilding: true}
                break;
            case "BED":
                options = {...typeOptions, isBed: true}
                break;
            case "FLOOR":               
              options = {...typeOptions, isFloor: true}
                break;               
            case "UNIT":               
              options = {...typeOptions, isUnit: true}
                break;               
            case "WING":               
              options = {...typeOptions, isWing: true}
                break;
            case "ROOM":               
              options = {...typeOptions, isRoom: true}
                break;               
            default:               
                break;
        }
        return options;
}

export const GetFilteredParentTypes = (treeData, key, type, ignoreKey = '')=>{
  if(!_.isEmpty(treeData)){
  let types = TreeNodeTypes.filter(t => (t.code !== 'ROOM' && t.code !=="BED")).filter(t => t.code !== type.code)
  types = !HasUnitsUnderBuilding(treeData, key, ignoreKey) ? types.filter(t => t.code !== "UNIT") : types;
  types = !HasWingsUnderBuilding(treeData, key, ignoreKey) ? types.filter(t => t.code !== "WING") : types;
  types = !HasFloorsUnderBuilding(treeData, key, ignoreKey) ? types.filter(t => t.code !== "FLOOR") : types; 
  return types;
  }
  return [];
}



export const OccupancyStatusOptions = [
  { code: "OCCUPIED", name: "Occupied" },
  { code: "UNOCCUPIED", name: "Unoccupied" },        
]

export const ReservationStatusOptions = [
  { code: "RESERVED", name: "Reserved" },
  { code: "AVAILABLE", name: "Available" },        
]

export const ActiveStatusOptions = [
  { code: 'Y', name: "Active" },
  { code: 'N', name: "Inactive" },        
]

export const OccupantTypeOptions = [
  { code: "CLIENT", name: "Client" },
  { code: "DEPENDENT", name: "Dependent" },        
]

export const ClientTypeOptions = [
  { code: "CLIENT", name: "Client" },
  { code: "PENDING_CLIENT", name: "Pending Client" },        
]


export const Severity = {
  Info:"p-button-info",
  Success:"p-button-success",
  Warning:"p-button-warning",
  Danger: "p-button-danger"
}

export const WaitlistPriority = [
  {name:"Highest", code:"HIGHEST", id:1},
  {name:"High", code:"HIGH", id:2},
  {name:"Medium", code:"MEDIUM", id:3},
  {name:"Low", code:"LOW", id:4},
  {name:"Lowest", code:"LOWEST", id:5},
]
